import { type PortfolioPreferences } from '../../types/portfolio.types';

export const DISPLAY_NAME_SUBTITLE_DEFAULT = "Choose the name you'd like to display on the cover.";
export const DISPLAY_NAME_SUBTITLE_CUSTOM_LOGO_SELECTED = "Choose the name you'd like to display on the cover and document footer.";

export const PORTFOLIO_COVER_BATH_PUBLIC_ID = 'siteassets/projects/portfolio/ferguson-home-baths.jpg';
export const PORTFOLIO_COVER_KITCHEN_PUBLIC_ID = 'siteassets/projects/portfolio/ferguson-home-kitchens.jpg';

export const NON_PERSISTED_FIELDS = [
	'includePurchasedItems',
	'includeNonpurchasedItems',
	'includePurchasedLabel',
	'groups',
	'productCategories',
	'customFileName',
	'includedBids',
	'shouldAdjustPrice'
];

export const PERSISTED_FIELDS: (keyof PortfolioPreferences)[] = [
	'addressType',
	'addressId',
	'displayNameChoice',
	'includeExpertDetails',
	'layoutType',
	'includeFirstProductComment',
	'includeTableOfContents',
	'includeSpecSheets',
	'includeInstallGuide',
	'includeWarrantyInfo',
	'includeOwnersManual',
	'includeAdditionalDocs',
	'itemHeadlineType',
	'includeItemDescription',
	'includeItemFinish',
	'priceType',
	'includeBillOfMaterials',
	'includeTermsAndConditions',
	'addNotes',
	'revisionTime',
	'pmgExpiration',
	'coverImage',
	'coverImageUrl',
	'logo',
	'logoUrl',
	'projectNotes',
	'customAddress',
	'consolidateDuplicateDocs',
	'displayName',
	'zipCode'
];

export const PORTFOLIO_STORAGE_KEY_PREFIX = 'portfolio-preferences';

export const LIST_PRODUCT_COUNT = 9;
